import { MAX_CHAR_ERROR } from 'common/constants/messages/validations';
import { USER_EMAIL_MAX_LENGTH, USER_NAME_MAX_LENGTH } from 'common/constants/userSchemaBase';

export const SIGN_UP_FORM_ERROR = 'Fix the following errors before continuing.';
export const SIGN_UP_SUBMIT_ERROR = 'Unable to create your account right now. Please try again.';
export const SIGN_UP_RESEND_MISSING_EMAIL_ERROR
  = 'We could not determine which email to resend. Return to sign up and try again.';
export const SIGN_UP_RESEND_FAILURE_MESSAGE = 'Unable to resend the activation email right now. Please try again later.';
export const SIGN_UP_RESEND_SUCCESS_MESSAGE = 'A new activation email has been sent.';
export const SIGN_UP_FOOTER_PROMPT = 'Have an account?';
export const SIGN_UP_FOOTER_SIGN_IN_LABEL = 'Sign in';
export const SIGN_UP_TITLE_LEAD = 'Create';
export const SIGN_UP_TITLE_TAIL = 'New Account';
export const SIGN_UP_FIRST_NAME_LABEL = 'Name';
export const SIGN_UP_FIRST_NAME_PLACEHOLDER = 'John';
export const SIGN_UP_FIRST_NAME_REQUIRED_ERROR = 'Enter your name.';
export const SIGN_UP_FIRST_NAME_MAX_LENGTH = USER_NAME_MAX_LENGTH;
export const SIGN_UP_FIRST_NAME_MAX_LENGTH_ERROR = MAX_CHAR_ERROR(SIGN_UP_FIRST_NAME_MAX_LENGTH);
export const SIGN_UP_LAST_NAME_LABEL = 'Last Name';
export const SIGN_UP_LAST_NAME_PLACEHOLDER = 'Doe';
export const SIGN_UP_LAST_NAME_REQUIRED_ERROR = 'Enter your last name.';
export const SIGN_UP_LAST_NAME_MAX_LENGTH = USER_NAME_MAX_LENGTH;
export const SIGN_UP_LAST_NAME_MAX_LENGTH_ERROR = MAX_CHAR_ERROR(SIGN_UP_LAST_NAME_MAX_LENGTH);
export const SIGN_UP_EMAIL_LABEL = 'Email';
export const SIGN_UP_EMAIL_PLACEHOLDER = 'johndoe@scalar.io';
export const SIGN_UP_EMAIL_REQUIRED_ERROR = 'Enter your email.';
export const SIGN_UP_EMAIL_FORMAT_ERROR = 'Enter a valid email.';
export const SIGN_UP_EMAIL_MAX_LENGTH = USER_EMAIL_MAX_LENGTH;
export const SIGN_UP_EMAIL_MAX_LENGTH_ERROR = MAX_CHAR_ERROR(SIGN_UP_EMAIL_MAX_LENGTH);
export const SIGN_UP_PASSWORD_LABEL = 'Create Password';
export const SIGN_UP_PASSWORD_PLACEHOLDER = '***************';
export const SIGN_UP_PASSWORD_REQUIRED_ERROR = 'Create your password.';
export const SIGN_UP_CONFIRM_PASSWORD_LABEL = 'Confirm Password';
export const SIGN_UP_CONFIRM_PASSWORD_PLACEHOLDER = '***************';
export const SIGN_UP_CONFIRM_PASSWORD_REQUIRED_ERROR = 'Confirm your password.';
export const SIGN_UP_SUBMIT_LABEL = 'Sign up now';
export const SIGN_UP_CONFIRMATION_TITLE = 'Account created';
export const SIGN_UP_CONFIRMATION_DESCRIPTION = 'An activation message was send to your email.';
export const SIGN_UP_RESEND_ACTION_LABEL = 'Resend activation message';
